import React, {useState,useEffect} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment-timezone'
import { useDispatch, useSelector } from 'react-redux'

import { timezoneDate } from 'utils'
import DatePicker from "react-datepicker";
import "./react-datepicker.css";

const defaultStyle = {
    backgroundColor: null,
    padding: 0,
    margin: 0,
    boxShadow: null,
    border: null,
}

const Container = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    padding: ${props => props.styles.padding};
    margin: ${props => props.styles.margin};
    box-shadow: ${props => props.styles.boxShadow};
    border: ${props => props.styles.border};
    border-radius: 5px;
`

const DateSelector = props => {
    const {
        type,
        date,
        startDate,
        endDate,
        onSelect,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const user = useSelector((state) => state.auth.user)
    const timezone = user['timezone'] 
    const [start, setStart] = useState(type === 'date' && date ? date
                                    : type === 'dateRange' && startDate ? startDate
                                    : moment().tz(timezone));
    const [end, setEnd] = useState(endDate || moment().tz(timezone));

    const selectRange = dates => {
        let [startSelected, endSelected] = dates;
        startSelected = startSelected && timezoneDate(startSelected, timezone, true)
        endSelected = endSelected && timezoneDate(endSelected, timezone, true)
        setStart(startSelected);
        setEnd(endSelected);
        onSelect([startSelected, endSelected])
    };

    const selectDate = date => {
        let selected = timezoneDate(date, timezone, true)

        setStart(selected)
        onSelect(selected)
    }
    
    let input;
    switch (type) {
        case 'date':
            input = <DatePicker inline
                    selected={start && start.toDate()}
                    onChange={selectDate}/>
            break
        case 'dateRange':
            input = <DatePicker inline useWeekdaysShort={false}
                        selected={start && start.toDate()}
                        onChange={selectRange}
                        startDate={start && start.toDate()}
                        endDate={end && end.toDate()}
                        selectsRange/>
            break
        default:
            input = <DatePicker inline
                        selected={start && start.toDate()}
                        onChange={selectDate}/>
            break
    }

    return (<Container styles={updatedStyle}>{input}</Container>)
}

export default DateSelector;

DateSelector.propTypes = {
    type: PropTypes.oneOf(['date', 'daterange']),
    // date: PropTypes.instanceOf(Date),
    // startDate: PropTypes.instanceOf(Date),
    // endDate: PropTypes.instanceOf(Date),
    onSelect: PropTypes.func.isRequired
}